import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarRelacaoVendasPorVendedor(api, parametros) {
    parametros.operacao = 'buscarRelacaoVendasPorVendedor';

    let retorno = {};
    await api.santriGET('/rest/relacaoVendasPorVendedor', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RRelacaoVendasPorVendedor.js